import React from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  Button,
  Grid,
} from '@material-ui/core';
import history from 'src/history';
import { TaskDetailInfo } from 'src/legacy/components/HomePage/OnboardingTasksSection/helper';
import { UrlUtils } from 'src/utils';
import { Body, Heading, TextLink } from 'copilot-design-system';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3.5),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2.5, 3),
      },
    },
    descriptionWrapper: {
      marginTop: theme.spacing(0.25),
      minWidth: '250px',
      minHeight: '40px',
    },
    illustrationWrapper: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    illustration: {
      maxWidth: '100%',
      marginLeft: theme.spacing(3),
      maxHeight: 160,
    },
    actionButtonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing(3),
      marginTop: theme.spacing(2.75),
    },
  }),
);

interface TaskProps {
  taskData: TaskDetailInfo;
}

export const TaskDetails: React.FC<TaskProps> = ({ taskData }) => {
  const classes = useStyles();

  const { buttonLabel, routePath } = taskData;
  const isButtonVisible = buttonLabel !== undefined && routePath !== undefined;

  return (
    <Grid container className={classes.root}>
      <Grid item xs>
        <Heading size="lg">{taskData.detailTitle ?? taskData.title}</Heading>
        <div className={classes.descriptionWrapper}>
          <Body size="sm" className="text-secondary leading-[21px]">
            {taskData.description}
          </Body>
        </div>
        <div className={classes.actionButtonContainer}>
          {isButtonVisible && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => history.push(routePath)}
            >
              {buttonLabel}
            </Button>
          )}
          <TextLink
            className="text-base text-black-heading underline hover:no-underline active:no-underline"
            variant="secondary"
            href={taskData.learnMoreLink}
            target={
              // determining action path type: external or internal
              // when action path external url (starts with http/s)
              UrlUtils.startsWithProtocol(taskData.learnMoreLink)
                ? '_blank'
                : undefined
            }
          >
            Learn More
          </TextLink>
        </div>
      </Grid>
      <Grid className={classes.illustrationWrapper} item xs>
        <img
          className={classes.illustration}
          src={`/images/${taskData.illustrationName}.jpg`}
          alt="Task illustration"
        />
      </Grid>
    </Grid>
  );
};
